import React from 'react'
import { gbInstitucionalTheme, Theme } from '@grupoboticario/flora'
import { Box } from '@grupoboticario/flora-react-box'
import { CSS } from '@grupoboticario/flora-react-system'
import { resetCssStyles } from './reset'

export type FloraProviderProps = {
  resetCSS?: boolean
  children: React.ReactNode
  css?: CSS
  /**
   * Must be a valid theme object
   * @default gbInstitucionalTheme
   * @see @grupoboticario/flora
   */
  theme?: Theme
}

if (typeof window !== 'undefined' && 'ResizeObserver' in window === false) {
  window.ResizeObserver = require('@juggle/resize-observer').ResizeObserver
}

/**
 * @component
 * @name FloraProvider
 * @example
 * import { gbInstitucionalTheme } from '@grupoboticario/flora'
 * import { FloraProvider } from '@grupoboticario/flora-react'
 * <>
 * <FloraProvider theme={gbInstitucional}>
 *   <MyComponent />
 *   </FloraProvider>
 * </>
 * @description
 * Use to provide a theme to the application
 * @tutorial https://flora.gb.tech/docs/components/core/flora-provider
 */
export const FloraProvider = ({
  resetCSS = true,
  theme = gbInstitucionalTheme,
  children,
  css,
}: FloraProviderProps) => {
  resetCSS && resetCssStyles()

  React.useEffect(() => {
    document.documentElement.classList.add(theme)
  }, [theme])

  return (
    <>
      <Box data-flora="provider" className={theme} css={css}>
        {children}
      </Box>
    </>
  )
}
